/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Chatgpt_Dev_ModeInputs */

const en_mcp_chatgpt_dev_mode = /** @type {(inputs: Mcp_Chatgpt_Dev_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In ChatGPT on the web, open Settings, then Security and login, and turn on Developer mode.`)
};

const es_mcp_chatgpt_dev_mode = /** @type {(inputs: Mcp_Chatgpt_Dev_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ChatGPT en la web, abre Settings, luego Security and login, y activa Developer mode.`)
};

/**
* | output |
* | --- |
* | "In ChatGPT on the web, open Settings, then Security and login, and turn on Developer mode." |
*
* @param {Mcp_Chatgpt_Dev_ModeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_chatgpt_dev_mode = /** @type {((inputs?: Mcp_Chatgpt_Dev_ModeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Chatgpt_Dev_ModeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_chatgpt_dev_mode(inputs)
	return en_mcp_chatgpt_dev_mode(inputs)
});